import { notification } from 'antd';
import {
  fetchParentAllTypes,
  fetchParentById,
  fetchParentPartitions,
  fetchParentShopList,
  submitParentInfo,
  submitParentInfoV2,
} from '@/services/api';
import router from 'umi/router';
import cloneDeep from 'lodash/cloneDeep';
import { produce } from 'immer';

const DEFAULT_STATUS = {
  allTypes: [], // 现有父商户的类目（非叶子类目 或 根类目）
  currentParentList: [], // 当前，该门店的父商户列表
  shopList: [], // 可选的父商户列表
  listErrorMsg: '', // 列表错误信息
  currentParentListOrigin: [],
  parentPartitions: {},
  // 处理结果中 成功 失败都有的情况 可以用此页面展示
  submitList: [], // 提交的列表
  resultList: [], // 返回的结果列表
  aiResult: [], // ai返回结果
};

export default {
  namespace: 'parent',
  state: cloneDeep(DEFAULT_STATUS),
  effects: {
    // 父子关系报错相关
    *fetchParentAllTypes({ payload }, { call, put }) {
      const allTypes = (yield call(fetchParentAllTypes)) || [];
      if (allTypes) {
        yield put({
          type: 'setField',
          payload: { allTypes },
        });
      }
    },
    *fetchParentById({ payload }, { call, put, all }) {
      const currentParentList = (yield call(fetchParentById, payload)) || [];
      if (currentParentList) {
        yield put({
          type: 'setField',
          payload: {
            currentParentList,
            currentParentListOrigin: cloneDeep(currentParentList),
          },
        });
        yield put({ type: 'updateParentPartitions' });
      }
    },
    *updateParentPartitions(_, { all, select, put }) {
      const currentParentList = yield select(state => state.parent.currentParentList);
      if (currentParentList) {
        yield all(
          currentParentList.map(i =>
            put({
              type: 'fetchParentPartitions',
              payload: i,
            })
          )
        );
      }
    },
    *fetchParentPartitions({ payload }, { call, put }) {
      if (payload.buType !== 'MALL') return;
      const partition = yield call(fetchParentPartitions, { shopId: payload.parentShopId }) || [];
      yield put({
        type: 'addParentPartition',
        payload: {
          ...payload,
          partition,
        },
      });
    },
    *fetchParentShopList({ payload }, { call, put }) {
      let listErrorMsg = '';
      const shopList = yield call(fetchParentShopList, payload, ({ msg = '' }) => {
        listErrorMsg = msg;
      });
      yield put({
        type: 'setField',
        payload: {
          shopList: shopList || [],
          listErrorMsg:
            shopList && shopList.length
              ? ''
              : listErrorMsg
                ? listErrorMsg
                : payload.keyword
                  ? '附近无匹配结果，请重新搜索'
                  : '无匹配结果',
        },
      });
    },
    *submitParentInfo({ payload }, { call, put }) {
      let result;
      const { code, data, msg } = yield call(submitParentInfoV2, payload);
      if (code === 200 && data) {
        result = {
          aiResult: data.aiResult || [],
        };
        if (data.flowResult && data.flowResult.length) {
          const flowIds = data.flowResult.map(item => item.flowId);
          yield put({
            type: 'success/setSuccessField',
            payload: {
              flowId: flowIds,
              successTextHtml: msg,
            },
          });
          router.push('/errors/result/success');
        }
      } else {
        notification.error({
          message: msg,
          duration: 0,
        });
      }
      yield put({
        type: 'setField',
        payload: {
          aiResult: [],
          ...result,
        },
      });
    },
  },
  reducers: {
    setField(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
    addParentPartition(state, action) {
      const { payload } = action;
      return produce(state, draft => {
        draft.parentPartitions[payload.parentShopId] = payload.partition;
      });
    },
    resetData() {
      return cloneDeep(DEFAULT_STATUS);
    },
  },
};
